import React from 'react';

import { Box } from '@chakra-ui/react';
import { components } from 'react-select';

export const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      {props.getValue().length ? (
        <Box
          fontSize="xs"
          color="primary"
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            // react-select doesn't pass custom props to its components; read
            // onReset from selectProps and don't throw when it's missing.
            (props.selectProps?.onReset ?? props.onReset)?.();
          }}
          _hover={{ cursor: 'pointer' }}
          fontWeight={600}
        >
          Clear
        </Box>
      ) : (
        <Box />
      )}
    </components.DropdownIndicator>
  );
};
